import config from './index';
import { hasSystemMembership } from '../modules/session';

export interface PasswordPolicy {
  minLength: number;
  maxLength: number;
}

/**
 * System-level credentials must meet a longer minimum (PCI DSS). Held here rather than in
 * constants/index so the validationHelper test's module mock cannot silently blank it.
 */
export const SYSADMIN_MIN_PASSWORD_LENGTH = 12;

/** Applies to charity, donor and fundraiser accounts, and whenever the tier is unknown. */
export const defaultPasswordPolicy: PasswordPolicy = {
  minLength: config.MIN_PASSWORD_LENGTH,
  maxLength: config.MAX_PASSWORD_LENGTH
};

export const sysadminPasswordPolicy: PasswordPolicy = {
  minLength: SYSADMIN_MIN_PASSWORD_LENGTH,
  maxLength: config.MAX_PASSWORD_LENGTH
};

/**
 * The policy for an account, from its admin memberships. Any System membership counts, whatever
 * the role: Owner and Viewer are in scope as well as Admin.
 */
export const getPolicyForMemberships = (
  adminMemberships?: any[] | null
): PasswordPolicy =>
  hasSystemMembership(adminMemberships)
    ? sysadminPasswordPolicy
    : defaultPasswordPolicy;

/**
 * The policy the API reported for an account, used where memberships are not available, such as
 * invite acceptance before the user is authenticated. Falls back to the default when absent, so
 * an older API simply behaves as it did before.
 */
export const getPolicyFromApi = (
  policy?: Partial<PasswordPolicy> | null
): PasswordPolicy => ({
  minLength: policy?.minLength ?? defaultPasswordPolicy.minLength,
  maxLength: policy?.maxLength ?? defaultPasswordPolicy.maxLength
});
